<template>
  <section class="flex justify-center min-h-screen text-center items-end md:items-center pb-5 pl-2 pr-2">
    <div class="w-full h-auto flex flex-col bg-white rounded pt-5 pb-5 md:max-w-sm">
      <div class="w-full flex justify-center mb-10">
        <img
          v-if="error.statusCode === 404"
          v-lazy-load data-src="@/assets/icon/icon-404.svg"
          alt=""
        >
        <img
          v-else
          v-lazy-load data-src="@/assets/icon/icon-500.svg"
          alt=""
        >
      </div>
      <div class="text-lg my-6">
        <template v-if="error.statusCode === 404 || error.message === 'Not Found'">
          Halaman Tidak Ditemukan
        </template>
        <template v-else>
          Terjadi masalah dalam<br>
          mengakses halaman. Silakan<br>
          coba beberapa saat lagi.
        </template>
      </div>
      <div class="links mt-6">
        <template v-if="error.statusCode === 404 || error.message === 'Not Found'">
          <yes-button
            round
            variant="primary"
            class="px-8"
            :icon-left="false"
            :icon-right="true"
            icon="chevron-circle-right"
            @click="handlingGo('home')"
          >
            Kembali ke halaman utama
          </yes-button>
        </template>
        <template v-else>
          <yes-button
            round
            :icon-left="false"
            :icon-right="true"
            icon="sync"
            variant="primary"
            class="px-8"
            @click="handlingGo('refresh')"
          >
            <span class="mr-5 ml-5">Refresh</span>
          </yes-button>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Error',
  layout: 'blank',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  methods: {
    handlingGo (val) {
      if (val === 'home') {
        this.$router.push('/')
      } else if (val === 'refresh') {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped>

</style>
